import { gql } from '@apollo/client';

import {
  CREATE_COMMENT_OPERATION,
  ADD_ATTACHMENTS_TO_CASE_OPERATION,
  CREATE_CASE_OPERATION,
} from 'utils/constants';

export const ADD_COMMENT_TO_CASE = gql`
  mutation ${CREATE_COMMENT_OPERATION}($input: RmaCaseCommentInput!) {
    addCommentToCase(input: $input) {
      comment {
        id
        comment
        contactId
        createdBy {
          name
        }
        createdAt
      }
      attachments {
        id
        name
        url
        description
        createdAt
      }
    }
  }
`;

export const ADD_ATTACHMENTS_TO_CASE = gql`
  mutation ${ADD_ATTACHMENTS_TO_CASE_OPERATION}($input: RmaCaseAttachmentInput!) {
    addAttachmentsToCase(input: $input) {
      id
      name
      url
      description
      createdAt
    }
  }
`;

export const CREATE_CASE = gql`
  mutation ${CREATE_CASE_OPERATION}($case: RmaCaseInput) {
    createRmaCase(input: $case) {
      id
      caseNumber
    }
  }
`;
